(() => {
  const brandPattern = /(?:https?:\/\/|www\.)[^\s<>"']+|[\w.+-]+@[\w.-]+\.[a-z]{2,}|\belys[eé][eé][\w.-]*\.(?:com|de|net)\b|\belys[eé][eé]\s+(?:Uhren|Watches)\s+GmbH\b|\belys[eé][eé](?:\s?1960)?\b/gi;
  const brandOnly = /^elys[eé][eé](?:\s?1960)?$/i;
  const attributes = ['alt', 'title', 'aria-label', 'placeholder'];
  const excluded = 'script, style, textarea, input, [contenteditable], #preview-bar-iframe';
  const rebrand = (text, protectedAt = () => false) => text.replace(brandPattern, (match, offset) =>
    brandOnly.test(match) && !protectedAt(offset) ? 'SAVOY' : match
  );

  function updateBranding() {
    const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
      acceptNode: node => node.parentElement?.closest(excluded) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT
    });
    const nodes = [];
    let text = '';
    while (walker.nextNode()) {
      nodes.push({ node: walker.currentNode, offset: text.length });
      text += walker.currentNode.data + '\n';
    }
    const companyRanges = Array.from(text.matchAll(/\belys[eé][eé]\s+(?:Uhren|Watches)\s+GmbH\b/gi),
      match => [match.index, match.index + match[0].length]);
    for (const { node, offset } of nodes) {
      const next = rebrand(node.data, index => companyRanges.some(([start, end]) => offset + index >= start && offset + index < end));
      if (next !== node.data) node.data = next;
    }
    for (const element of document.querySelectorAll(attributes.map(name => `[${name}]`).join(','))) {
      if (element.closest('[contenteditable]')) continue;
      for (const name of attributes) {
        const value = element.getAttribute(name);
        if (value === null) continue;
        const next = rebrand(value);
        if (next !== value) element.setAttribute(name, next);
      }
    }
    const nextTitle = rebrand(document.title);
    if (nextTitle !== document.title) document.title = nextTitle;
    for (const element of document.querySelectorAll('meta[name="description"], meta[property="og:title"], meta[property="og:description"], meta[property="og:site_name"], meta[name="twitter:title"], meta[name="twitter:description"]')) {
      const next = rebrand(element.content);
      if (next !== element.content) element.content = next;
    }
  }

  function start() {
    updateBranding();
    let queued = false;
    new MutationObserver(records => {
      if (queued || !records.some(record => !record.target.parentElement?.closest(excluded))) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        updateBranding();
      });
    }).observe(document.body, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: attributes });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
